import styled from "@emotion/styled";

export const PricingSectionContainer = styled.section`
    width:80%;
    margin-top: 4rem;
    margin-bottom: 4rem;
    margin: auto;
`;

export const PricingSectionContentContainer = styled.div`
    text-align: center;
    // background: white;
    padding: 40px;
    border-radius: 20px;
`;

export const AboutContainer = styled.div`
    padding:40px;
    width:100%;
    background-color: white;
    border-radius: 20px;
`;
export const PricingSectionTitle = styled.h1`
    font-size: 30px;
    margin-bottom: 0.9rem;
    color: rgb(23, 59, 94);
`;

export const PricingSectionDescription = styled.p`
    font-size: 18px;
    line-height: 36px;
    max-width: 1000px;
    margin: auto;
    // color: gray;
`;

export const PricingCardContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 2rem;
    margin-bottom: 60px;
`;

export const ContactContainer = styled.div`
    display: flex;
    padding-top: 20px;
    gap: 40px;
    @media (max-width: 1024px) {
        flex-wrap:wrap;
    }
`;
